exports.components = {
  "component---src-pages-blogs-js": () => import("./../../../src/pages/blogs.js" /* webpackChunkName: "component---src-pages-blogs-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-templates-blog-details-js": () => import("./../../../src/templates/BlogDetails.js" /* webpackChunkName: "component---src-templates-blog-details-js" */)
}

